module.exports = __webpack_public_path__ + "static/media/Aluminum Corrugated Sheet_Corten.2128d2fc.jpg";